var R = Object.defineProperty, S = Object.defineProperties;
var b = Object.getOwnPropertyDescriptors;
var e = Object.getOwnPropertySymbols;
var i = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var m = (s, o, r) => o in s ? R(s, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : s[o] = r, t = (s, o) => {
  for (var r in o || (o = {}))
    i.call(o, r) && m(s, r, o[r]);
  if (e)
    for (var r of e(o))
      d.call(o, r) && m(s, r, o[r]);
  return s;
}, c = (s, o) => S(s, b(o));
var l = (s, o) => {
  var r = {};
  for (var a in s)
    i.call(s, a) && o.indexOf(a) < 0 && (r[a] = s[a]);
  if (s != null && e)
    for (var a of e(s))
      o.indexOf(a) < 0 && d.call(s, a) && (r[a] = s[a]);
  return r;
};
import { jsx as _ } from "react/jsx-runtime";
import "react";
import { d as j, e as F } from "./get-size-Bc1Pz5yf.js";
import { c as V } from "./create-vars-resolver-Bzbn9G-G.js";
import { u as k, B as q } from "./factory-ueRxoNOV.js";
import { u as z } from "./use-styles-DToiHEa6.js";
import { p as A } from "./polymorphic-factory-DufevJAl.js";
var n = { root: "m_1b7284a3" };
const C = {}, D = V((s, { radius: o, shadow: r }) => ({
  root: {
    "--paper-radius": o === void 0 ? void 0 : F(o),
    "--paper-shadow": j(r)
  }
})), u = A((s, o) => {
  const r = k("Paper", C, s), p = r, {
    classNames: a,
    className: v,
    style: y,
    styles: f,
    unstyled: h,
    withBorder: P,
    vars: w,
    radius: E,
    shadow: G,
    variant: g,
    mod: x
  } = p, B = l(p, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "withBorder",
    "vars",
    "radius",
    "shadow",
    "variant",
    "mod"
  ]), N = z({
    name: "Paper",
    props: r,
    classes: n,
    className: v,
    style: y,
    classNames: a,
    styles: f,
    unstyled: h,
    vars: w,
    varsResolver: D
  });
  return /* @__PURE__ */ _(
    q,
    t(c(t({
      ref: o,
      mod: [{ "data-with-border": P }, x]
    }, N("root")), {
      variant: g
    }), B)
  );
});
u.classes = n;
u.displayName = "@mantine/core/Paper";
export {
  u as P
};
